export const shouldBeTreatedAsH1 = (url: string): boolean => {
  const h1Urls = [
    '/',
    '/campaign-fancl',
    '/payment_error',
    '/pickup_support',
    '/campaign/202304_referral',
    '/cart',
    '/japanese-sake',
    '/local-souvenirs/area/[areaPath]',
    '/order/complete',
    '/order/new',
    '/order/secondPayment',
    '/order/show',
  ];

  return h1Urls.includes(url);
};
